export const languageLevels = [
    "A1 - Breakthrough", "A2 - Waystage", "B1 - Threshold", "B2 - Vantage", "C1 - Effective Operational Proficiency", "C2 - Mastery"
];
export default {
    languageLevels
}